// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auth-container[data-v-9040f476] {\n  background: #f2f2f7;\n  min-height: 100vh;\n}\n.auth-container .form-container .logo[data-v-9040f476] {\n    text-align: center;\n    padding: 24px 40px;\n}\n.auth-container .form-container .logo img[data-v-9040f476] {\n      width: 150px;\n      border-radius: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
